module.exports = __webpack_public_path__ + "img/zhangdelun.c81e0dfa.jpg";